(() => {
  if (window.routineAutoVideoReady) return;
  window.routineAutoVideoReady = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const connection = navigator.connection || {};
  const saveData = connection.saveData || /(^|-)2g$|3g/.test(connection.effectiveType || '');
  if (reduceMotion || saveData) return;

  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  const init = () => {
    const videos = Array.from(document.querySelectorAll('[data-auto-video] video'));
    if (!videos.length) return;

    videos.forEach((video) => {
      video.muted = true;
      // Once the shopper uses the controls, leave the video to them.
      const takeOver = () => (video.dataset.userControl = 'true');
      video.addEventListener('volumechange', () => { if (!video.muted) takeOver(); });
      video.addEventListener('seeking', takeOver);
    });

    const play = (video) => {
      if (video.dataset.userControl === 'true') return;
      const attempt = video.play();
      if (attempt && attempt.catch) attempt.catch(() => {});
    };
    const pause = (video) => {
      if (video.dataset.userControl === 'true' && !video.muted) return;
      video.pause();
    };

    if (canHover) {
      videos.forEach((video) => {
        const media = video.closest('[data-auto-video]');
        media.addEventListener('mouseenter', () => play(video));
        media.addEventListener('mouseleave', () => pause(video));
      });
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) play(entry.target);
          else pause(entry.target);
        });
      },
      { threshold: [0, 0.6] }
    );
    videos.forEach((video) => observer.observe(video));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
